<template>
  <page-outline 
    :title="$t('Webheader.connector_list_'+msgType+'_'+entitiesType)"
    :show-refresh="true"
    :refresh-disabled="activateSpinner"
    @refresh="onRefresh">
    
    <template slot="primaryActions">
      <app-button
        :text="$t('common.bck')"
        icon="fa-light fa-arrow-left"
        variant="primary"
        @click="goBack">
      </app-button>
    </template>
    
    <template slot="pageContent">
      <b-container fluid class="listPage">
        <b-tabs v-model="tabIndex" class="p-3 w-100" content-class="mt-3" nav-class="d-none">
          <b-tab title="S3">
            <b-col md="12">
              <spinner v-if="activateSpinner"></spinner>
              <div v-else>
                <b-table hover responsive
                         v-if="S3ConfigList.length > 0"
                         class="mt-3 table-striped"
                         :items="S3ConfigList"
                         :fields="S3ConfigFields"
                         selectable select-mode="single" @row-selected="seeS3ConfigDetails">

                  <template #cell(Prefix)="data">
                    <span v-if="data.item.Prefix !== ''">{{ data.item.Prefix }}</span>
                    <span v-else-if="data.item.PrefixArchiving !== ''">{{ data.item.PrefixArchiving }} </span>
                    <span v-else> - </span>
                  </template>
                </b-table>

                <div v-else class="d-flex justify-content-center">
                      <span class="noResult">
                        {{ $t('common.no_result') }}
                      </span>
                </div>
              </div>
            </b-col>
          </b-tab>
        </b-tabs>
      </b-container>
    </template>
  </page-outline>

</template>

<script>

import Spinner from '@/components/common/spinner.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import AppButton from "@/components/common/AppButton.vue"
import PageOutline from "@/components/common/PageOutline.vue";

export default {
  name: 'ConfigurationS3',
  components: {
    PageOutline,
    'app-button': AppButton,
    'spinner': Spinner
  },
  props: {
    msgType: {
      default: '2'
    },
    entitiesType: {
      default: '1'
    },
  },
  computed: {
    S3ConfigFields () {
      return [
        { key: 'ConfigName', label: this.$t('common.routing.config_name'), class: 'text-center' },
        { key: 'Region', label: this.$t('common.routing.region'), class: 'text-center text-truncate' },
        { key: 'URI', label: this.$t('common.routing.uri'), class: 'text-center text-truncate'},
        { key: 'Port', label: this.$t('common.routing.port'), class: 'text-center' },
        { key: 'BucketName', label: this.$t('common.routing.bucket_name'), class: 'text-center' },
        { key: 'Prefix', label: this.$t('common.routing.prefix'), class: 'text-center text-truncate' }
      ]
    },
  },
  data () {
    return {
      activateSpinner: false,
      pageCounter: 0,
      returnUrl: '',
      entityType: 0,
      tabName: 1,
      tabIndex: 0,
      S3ConfigList: []
    }
  },
  created () {
    this.returnUrl = '/entitiessettings/decentralised/SI'
    this.onRefresh()
  },
  methods: {
    generateUrlParams() {
      return  this.msgType + '/' + this.entitiesType
    },
    getConfigS3 () {
      let that = this
      this.$engine.firstOn().routing.config.s3.fetch({
        entityType: this.entitiesType,
        messageType: this.msgType
      }).then(resp => {
        let S3List = {}

        S3List = resp.data

        this.updateS3(S3List)
        this.activateSpinner = false

        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    onRefresh (index = 1) {
      this.activateSpinner = true
      this.pageCounter = 0
      
      this.getConfigS3()

      this.$f7.pullToRefreshDone()
    },
    seeS3ConfigDetails (items) {
      let config = items[0]
      let that = this

      this.$engine.firstOn().routing.config.clickedConfig = config
      loadPage(that, {url: '/routing/S3ConfigurationDetails/details/' + this.generateUrlParams() +'/'+ items[0].IdConfigS3})
    },
    updateS3 (S3List) {
      this.S3ConfigList = S3List.S3Config
    },
    goBack() {
      loadPage(this, {url: this.returnUrl})
    }
  }
}
</script>
